import { deepCopy, getDataScopeByPermission, getForwarderByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { IntransitUpdateService } from './../../services/intransit-update.service';
import { Component, EventEmitter, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DeliveryOrderService } from '../../services/delivery-order.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { DataScope } from 'src/app/core/models/data-scope';
import { IntransitParam } from 'src/app/core/models/transport-operation/intransit-param';

@Component({
  selector: 'laas-intransit-update',
  templateUrl: './intransit-update.component.html',
  styleUrls: ['./intransit-update.component.scss']
})
export class IntransitUpdateComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode= PermissionConstants.ViewIntransitUpdate;
  currentLang: string = this.laasSetting.language;
  searchForm: FormGroup;
  searchParams:IntransitParam;
  selectedRows: any[];
  preferenceKey: any;
  intransitColumns: any[];
  rows: any[];
  isLoading: boolean=false;
  isShowIntransitImport: boolean = false;
  isSearchFormOpen: boolean = true;
  forwarderOptions:any[]=[];
  facilityOptions:any[]=[];
  countryOptions:any[]=[];
  shipperCityOptions: any[] = [];
  allCityOptions: any[] = [];
  consigneeCityOptions: any[] = [];

  constructor(
    injector: Injector,
    private formBuilder: FormBuilder,
    private intransitUpdateService:IntransitUpdateService,
    private commonDataService: CommonDataService,
    private dOService: DeliveryOrderService,
    private dropdownOptionsService: DropdownOptionsService) {
    super(injector);

    this.searchForm = this.formBuilder.group({
      hawbs:[],
      shipperCountry:null,
      shipperCity:null,
      consigneeCountry: null,
      consigneeCity: null,
      forwarderCode:[],
      bookingDateStart:null,
      bookingDateEnd:null,
      pickUpDateStart:null,
      pickUpDateEnd:null,
      completeDeliveryTimeStart:null,
      completeDeliveryTimeEnd:null,
      etdStart:null,
      etdEnd:null,
      etaStart:null,
      etaEnd:null,
      edcStart:null,
      edcEnd:null,
      atdStart:null,
      atdEnd:null,
      ataStart:null,
      ataEnd:null,
      estimatedPortClearanceTimeStart:null,
      estimatedPortClearanceTimeEnd:null,
      actualPortClearanceTimeStart:null,
      actualPortClearanceTimeEnd:null
    });

    this.searchParams = {
      hawbs:[],
      dataScopes:null,
      shipperCountry:null,
      shipperCity:null,
      consigneeCountry: null,
      consigneeCity: null,
      forwarderCode:[],
      bookingDateStart:null,
      bookingDateEnd:null,
      pickUpDateStart:null,
      pickUpDateEnd:null,
      completeDeliveryTimeStart:null,
      completeDeliveryTimeEnd:null,
      etdStart:null,
      etdEnd:null,
      etaStart:null,
      etaEnd:null,
      edcStart:null,
      edcEnd:null,
      atdStart:null,
      atdEnd:null,
      ataStart:null,
      ataEnd:null,
      estimatedPortClearanceTimeStart:null,
      estimatedPortClearanceTimeEnd:null,
      actualPortClearanceTimeStart:null,
      actualPortClearanceTimeEnd:null
    }

    this.intransitColumns =[
      {field:'deliveryWarehouse',header:'IntransitImport.MainTable.deliveryWarehouse', sort:true},
      {field:'forwarderName',header:'IntransitImport.MainTable.forwarderName', sort:true},
      {field:'awbNumber',header:'IntransitImport.MainTable.awbNumber', sort:true},
      {field:'shipperName',header:'IntransitImport.MainTable.shipperName', sort:true},
      {field:'shipperCountry',header:'IntransitImport.MainTable.shipperCountry', sort:true},
      {field:'shipperCity',header:'IntransitImport.MainTable.shipperCity', sort:true},
      {field:'consigneeName',header:'IntransitImport.MainTable.consigneeName', sort:true},
      {field:'consigneeCountry',header:'IntransitImport.MainTable.consigneeCountry', sort:true},
      {field:'consigneeCity',header:'IntransitImport.MainTable.consigneeCity', sort:true},
      {field:'pieces',header:'IntransitImport.MainTable.pieces', sort:true},
      {field:'actWgt',header:'IntransitImport.MainTable.actWgt', sort:true},
      {field:'bookingDate',header:'IntransitImport.MainTable.bookingDate', sort:true},
      {field:'pickUpDate',header:'IntransitImport.MainTable.pickUpDate', sort:true},
      {field:'completeDeliveryTime',header:'IntransitImport.MainTable.completeDeliveryTime', sort:true},
      {field:'brandName',header:'IntransitImport.MainTable.brandName', sort:true},
      {field:'reference',header:'IntransitImport.MainTable.reference', sort:true},
      {field:'etd',header:'IntransitImport.MainTable.etd', sort:true},
      {field:'eta',header:'IntransitImport.MainTable.eta', sort:true},
      {field:'edc',header:'IntransitImport.MainTable.edc', sort:true},
      {field:'atd',header:'IntransitImport.MainTable.atd', sort:true},
      {field:'ata',header:'IntransitImport.MainTable.ata', sort:true},
      {field:'estimatedPortClearanceTime',header:'IntransitImport.MainTable.estimatedPortClearanceTime', sort:true},
      {field:'actualPortClearanceTime',header:'IntransitImport.MainTable.actualPortClearanceTime', sort:true},
      {field:'others',header:'IntransitImport.MainTable.others', sort:true},
      {field:'mawbNumber',header:'IntransitImport.MainTable.mawbNumber', sort:true},
      {field:'route',header:'IntransitImport.MainTable.route', sort:true},
      {field:'createDt',header:'IntransitImport.MainTable.createDt', sort:true},
      {field:'createUser',header:'IntransitImport.MainTable.createUser', sort:true},
      {field:'updateDt',header:'IntransitImport.MainTable.updateDt', sort:true},
      {field:'updateUser',header:'IntransitImport.MainTable.updateUser', sort:true}
    ]

    this.selectedRows = [];
    this.rows = [];

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (options: FacilityOptions[]) => {
        this.facilityOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionsService.getCountryOptions()
      .subscribe({
        next: (options: any[]) => {
          this.countryOptions = options.map(x => ({ label: x.countryName, value: x.countryCode }));
        }
      });

    this.dropdownOptionsService.getAllCityOptions()
    .subscribe({
      next: (options: any[]) => {
        this.allCityOptions = options.map(x => ({ label: x.name, value: x.enName, country: x.country }));
      }
    });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options.filter((x: any) => {
          return ( this.userProfile.userType === UserType.SuperAdmin.toString() ||
          this.userProfile.userType === UserType.Shipping.toString() ||
          getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });
  }

  searchBtnClick(){
    this.isLoading = true;
    this.searchParams =this.searchForm.value;
    this.searchParams.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);

    this.intransitUpdateService.queryIntransit(this.searchParams)
    .subscribe({
      next:(result)=>{
        this.rows=result;
        console.log(result);
      },
      complete:()=>{
        this.isLoading = false;
        this.isSearchFormOpen=false;
      }
    })
  }

  resetBtnClick(){
    this.searchForm.reset();
  }

  visibleChangeOfIntransitImport(val:boolean){
    this.isShowIntransitImport = val;
  }

  searchImport(hawbs:string[]){
    this.isLoading = true;
    if(!isNullOrEmpty(hawbs)){
      this.searchParams.hawbs = hawbs;
      this.searchParams.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
      this.intransitUpdateService.queryIntransit(this.searchParams)
      .subscribe({
        next:(result)=>{
          this.rows=result;
          console.log(result);
        },
        complete:()=>{
          this.isLoading = false;
          this.isSearchFormOpen=false;
        }
      });
    }else{
      this.isLoading = false;
    }
  }

  templateDownloadBtn(): void {

    var fileType = 'IntransitUpdate';
    var fileName = 'Intransit Update Template';

    this.commonDataService.getSystemParam(fileType).subscribe({
      next: result => {
        var searchObj = {
          sn: result[0].sn,
          version: result[0].version
        };

        this.dOService.downloadFile(searchObj).subscribe(x => {
          var blob = new Blob([x], { type: 'application/octet-stream' }); // application後面接下載的副檔名

          let downloadURL = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = fileName + '.xlsx';
          link.click();
        });
      }
    });
  }

  downloadExcelBtn($event: Event) {
    this.isLoading = true;
    this.searchParams = this.searchForm.value;
    this.searchParams.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);

    this.intransitUpdateService.exportExcel(this.searchParams).subscribe({
      next: result => {

        if (result == null || result.size == 0) {
          this.translateService.get('Common.Toast.NoData').subscribe({
            next: i18nResult => {
              this.toastService.info(i18nResult);
            }
          });
          this.isLoading = false;
        } else {
          const file = result;

          file.name = ("Intransit Update_"+new Date().toLocaleDateString() + ".xlsx");

          const url = URL.createObjectURL(file);
          let a: any = document.createElement('a');
          a.href = url
          a.download = file.name;
          a.click();
          URL.revokeObjectURL(url);
        }
      },
      complete: () => {
        this.isLoading = false;
      }
    })
  }

  getshipperCityOptions(): void {
    this.searchForm.value.shipperCity = "";
    this.shipperCityOptions = this.allCityOptions.filter(x => x.country == this.searchForm.value.shipperCountry);
  }

  getconsigneeCityOptions(): void {
    this.searchForm.value.consigneeCity = "";
    this.consigneeCityOptions = this.allCityOptions.filter(x => x.country == this.searchForm.value.consigneeCountry);
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case 'bookingDate':
        this.searchForm.controls.bookingDateStart.setValue(date.startDate);
        this.searchForm.controls.bookingDateEnd.setValue(date.endDate);
        break;
      case 'pickUpDate':
        this.searchForm.controls.pickUpDateStart.setValue(date.startDate);
        this.searchForm.controls.pickUpDateEnd.setValue(date.endDate);
        break;
      case 'completeDeliveryTime':
        this.searchForm.controls.completeDeliveryTimeStart.setValue(date.startDate);
        this.searchForm.controls.completeDeliveryTimeEnd.setValue(date.endDate);
        break;
      case 'etd':
        this.searchForm.controls.etdStart.setValue(date.startDate);
        this.searchForm.controls.etdEnd.setValue(date.endDate);
        break;
      case 'eta':
        this.searchForm.controls.etaStart.setValue(date.startDate);
        this.searchForm.controls.etaEnd.setValue(date.endDate);
        break;
      case 'edc':
        this.searchForm.controls.edcStart.setValue(date.startDate);
        this.searchForm.controls.edcEnd.setValue(date.endDate);
        break;
      case 'atd':
        this.searchForm.controls.atdStart.setValue(date.startDate);
        this.searchForm.controls.atdEnd.setValue(date.endDate);
        break;
      case 'ata':
        this.searchForm.controls.ataStart.setValue(date.startDate);
        this.searchForm.controls.ataEnd.setValue(date.endDate);
        break;
      case 'estimatedPortClearanceTime':
        this.searchForm.controls.estimatedPortClearanceTimeStart.setValue(date.startDate);
        this.searchForm.controls.estimatedPortClearanceTimeEnd.setValue(date.endDate);
        break;
      case 'actualPortClearanceTime':
        this.searchForm.controls.actualPortClearanceTimeStart.setValue(date.startDate);
        this.searchForm.controls.actualPortClearanceTimeEnd.setValue(date.endDate);
        break;
    }
  }
}
